import { t } from 'i18n'
import { memo } from 'react'
import { Pie } from 'react-chartjs-2'
import styled from 'styled-components'
import ChartContainer from './ChartContainer'

const StyledPieChart = styled(Pie)`
  margin-top: 2rem;
  width: 100% !important;
  max-height: 400px;
`

interface PieChartProps {
  labels: string[]
  data: number[]
  title: string
}

const PieChart = ({ labels, data, title }: PieChartProps) => {
  if (!data) return null

  const colors = [
    '#e60049',
    '#0bb4ff',
    '#50e991',
    '#e6d800',
    '#9b19f5',
    '#ffa300',
    '#dc0ab4',
    '#b3d4ff',
    '#00bfa0',
    '#7c1158',
    '#4421af',
    '#1a53ff',
    '#b2e061',
    '#bd7ebe',
    '#ffb55a',
    '#ffee65',
    '#27aeef'
  ]

  const options = {
    responsive: true,
    scales: {
      y: {
        display: false
      },
      x: {
        display: false
      }
    },

    plugins: {
      datalabels: {
        formatter: (value: any, ctx: any) => {
          let sum = 0
          const dataArr = ctx.chart.data.datasets[0].data
          dataArr.forEach((data: any) => {
            sum += data
          })
          const percentage = ((value * 100) / sum).toFixed(0) + '%'
          return percentage
        },
        backgroundColor: function (context: any) {
          return context.dataset.backgroundColor
        },
        color: 'white',
        padding: 0,
        display: 'auto'
      },

      labels: {
        render: 'percentage',
        colors: 'black'
      },

      legend: {
        position: 'right' as const,
        labels: {
          padding: 16,
          font: {
            size: 16
          },
          pointStyle: 'circle',
          usePointStyle: true
        }
      },
      title: {
        display: false
      }
    }
  }

  const defaultData = {
    labels: labels.map(label => t(label)),
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1
      }
    ]
  }

  return (
    <ChartContainer title={title}>
      <StyledPieChart data={defaultData} options={options} />
    </ChartContainer>
  )
}

export default memo(PieChart)
